import { gql } from "@apollo/client";

const GET_SHORT_TERM_LISTING = gql`
  query shortTermMobilities(
      $typeOfStudent: Int!,
      $page: Int!,
      $optionalSTLAFilters: OptionalSTLAFilters,
      $sortBy: String!){
      shortTermMobilities(
        typeOfStudent: $typeOfStudent,
        page: $page,
        optionalSTLAFilters: $optionalSTLAFilters,
        sortBy: $sortBy)
      {
        shortTermList{
          type
          STLAnid
          shortTermID
          title
          field_academic_year
          field_student_email
          field_student_birthdate
          field_esi
          field_planned_period_from
          field_planned_period_to
          field_la_status
          sending_institution
          receiving_institution
          sending_institution_hei_id
          receiving_institution_hei_id
          field_student_firstname
          field_student_lastname
          receiving_institution_hei
          sending_institution_hei
        }
        page
        nextLink
      }
    }`
;

export default GET_SHORT_TERM_LISTING;
